// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s4fFiSW_xHFFyH {
  max-height: calc(100vh - 48px);
}

.uNwM9EkqtwQisv {
  flex-direction: column;
  min-height: 0;
  max-height: calc(100vh - 48px);
  display: flex;
}

.wq06h5CRjYvhWX {
  padding: var(--ds-space-300, 24px);
  justify-content: space-between;
  align-items: center;
  column-gap: var(--ds-space-200, 16px);
  background-color: var(--ds-surface, #fff);
  flex: none;
  display: flex;
}

.wq06h5CRjYvhWX .obfPGDQNw79bwk {
  justify-content: flex-start;
  align-items: center;
  display: flex;
}

.wq06h5CRjYvhWX .obfPGDQNw79bwk .DSDdrST4gTjvGP {
  border-radius: var(--ds-radius-full, 50%);
}

.wq06h5CRjYvhWX .jPkfXTJVxg44uL {
  justify-content: center;
  align-items: center;
  column-gap: var(--ds-space-100, 8px);
  display: flex;
}

.wq06h5CRjYvhWX .jPkfXTJVxg44uL p {
  margin: var(--ds-space-0, 0);
  font: var(--ds-font-body, normal 14px / 20px var(--ds-font-family-body, sans-serif));
  text-align: center;
}

.wq06h5CRjYvhWX .XRoy2n9IUT9jca {
  justify-content: flex-end;
  align-items: center;
  display: flex;
}

.HCxpL2ag969XAI {
  background-color: var(--ds-surface, #fff);
  background-image: radial-gradient(184% 82% at 28% 118%, #2787eec7 0%, #0371f8ab 28%, #76aaf65c 52%, #fff0 76%), radial-gradient(158% 94% at 88% 101%, #8505ef 0%, #a076e49c 30%, #d3b5f847 55%, #fff0 78%);
  flex: 700px;
  min-height: 0;
  overflow: hidden auto;
}

.a2uB7IXV281y74 {
  --smart-schedule-slide-in-start: 100%;
  --smart-schedule-slide-out-end: -100%;
  height: 100%;
  position: relative;
}

.lXiahydzdlGjw6 {
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  will-change: transform;
  width: 100%;
  height: 100%;
  position: absolute;
}

.pLNIUMBzehp29F {
  transform: translateX(var(--smart-schedule-slide-in-start));
}

.wLVblkQih5AzB0 {
  transition: transform .3s;
  transform: translateX(0);
}

.XgreKE5XSbkdrE {
  pointer-events: none;
  transform: translateX(0);
}

.FWo_NNzZfKVnuv {
  transform: translateX(var(--smart-schedule-slide-out-end));
  transition: transform .3s;
}

.XDZynj5cJ6JpVD {
  --smart-schedule-slide-in-start: 100%;
  --smart-schedule-slide-out-end: -100%;
}

.tsac5iFO9Otcx4 {
  --smart-schedule-slide-in-start: -100%;
  --smart-schedule-slide-out-end: 100%;
}

@media (prefers-reduced-motion: reduce) {
  .pLNIUMBzehp29F, .wLVblkQih5AzB0, .XgreKE5XSbkdrE, .FWo_NNzZfKVnuv {
    transition: none;
    transform: none;
  }
}
`, ""]);
// Exports
export var dialog = `s4fFiSW_xHFFyH`;
export var dialogLayout = `uNwM9EkqtwQisv`;
export var header = `wq06h5CRjYvhWX`;
export var headerLeft = `obfPGDQNw79bwk`;
export var previousButton = `DSDdrST4gTjvGP`;
export var headerCenter = `jPkfXTJVxg44uL`;
export var headerRight = `XRoy2n9IUT9jca`;
export var contentWrapper = `HCxpL2ag969XAI`;
export var pageTransition = `a2uB7IXV281y74`;
export var page = `lXiahydzdlGjw6`;
export var slideInStart = `pLNIUMBzehp29F`;
export var slideInEnd = `wLVblkQih5AzB0`;
export var slideOutStart = `XgreKE5XSbkdrE`;
export var slideOutEnd = `FWo_NNzZfKVnuv`;
export var slideForward = `XDZynj5cJ6JpVD`;
export var slideBackward = `tsac5iFO9Otcx4`;
export default ___CSS_LOADER_EXPORT___;
